import initialState from './partnerReviewInitialState';
import mutations from './partnerReviewMutation';
import actions from './partnerReviewAction';

const getters = {
  prTaxTotal(state) {
    const {
      hardwareTax,
      subscriptionTax,
    } = state;
    let taxTotal = 0;
    if (hardwareTax.taxTotal) {
      taxTotal += hardwareTax.taxTotal;
    }
    if (subscriptionTax.taxTotal) {
      taxTotal += subscriptionTax.taxTotal;
    }
    return taxTotal;
  },
  prOrderTotal(state, getter) {
    const {
      prTaxTotal,
    } = getter;
    const {
      order: {
        orderTotal,
      },
    } = state;
    return orderTotal + prTaxTotal;
  },
};

const partnerReviewModule = {
  state: initialState(),
  mutations,
  actions,
  getters,
};

export default partnerReviewModule;
